<template>
  <component v-if="template" :is="template" :info />
  <!-- <Suspense v-if="template">
    <template #default>
      <component :is="template" :info />
    </template>
    <template #fallback>
      <div>加载中...</div>
    </template>
  </Suspense> -->
</template>

<script setup>
import { getGoogleTemplatesInfo } from '@/api/google';

const info = ref(null);
const template = shallowRef(null);
const id = useRoute().query.tid;

const templates = {
  GoogleStore: defineAsyncComponent(() => import('@/views/google/store.vue')),
  GoogleVideo: defineAsyncComponent(() => import('@/views/google/video.vue')),
}

showLoadingToast('loading...');
if (id) {
  getGoogleTemplatesInfo({ id })
    .then(async ({code, data}) => {
      closeToast();
      console.log('data', data);
      if (code === 1) {
        info.value = data;
        template.value = templates[data.type] || null;
        // template.value = templates.GoogleVideo;
        
        if (!template.value) {
          showFailToast('Invalid template');
        }
      } else {
        showFailToast(data.msg);
      }
    });
} else {
  showFailToast('Invalid tid');
}
</script>

